<template>
  <!-- 刪除訂單視窗 -->
  <ui-modal
    ref="visibleOrderModal"
    content-class="delete-order-dialog"
    :forcing="true"
    :header-title="$t('delete_order_title')"
    :hide-overlay="false"
  >
    <v-sheet class="delete-order-container" min-height="116">
      <p class="mb-6">{{ $t('delete_order_content') }}</p>
    </v-sheet>

    <template #buttons>
      <div class="event-buttons-group">
        <v-btn class="cancel-btn large--btn mr-4" min-width="32" height="40" elevation="0" @click="hideModal">
          {{ $t('all_cancel') }}
        </v-btn>

        <v-btn
          class="confirm-btn large--btn"
          :loading="isLoading"
          min-width="32"
          height="40"
          color="orange50"
          elevation="0"
          @click="confirmVisibleOrder"
        >
          {{ $t('delete_order_button') }}
        </v-btn>
      </div>
    </template>
  </ui-modal>
</template>

<script>
import UiModal from '@/components/dialog/ui-modal'

export default {
  name: 'CancelOrderModal',
  components: {
    UiModal,
  },
  props: {
    orderId: { type: [String, Number], default: '' },
  },
  setup() {
    const localePath = useLocalePath()
    return { localePath }
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    confirmVisibleOrder() {
      this.$store
        .dispatch('orders/visibleOrder', this.orderId)
        .then(res => {
          if (res.code === 0) {
            this.hideModal()
            this.$router.replace(this.localePath({ name: 'orders-list' }))
          } else {
            throw res
          }
        })
        .catch(error => {
          this.hideModal()
          this.$store.dispatch('dialog/setRootMessageOption', { status: true, options: { message: error.message } })
        })
    },
    showModal() {
      this.$refs.visibleOrderModal.showModal()
    },
    hideModal() {
      this.$refs.visibleOrderModal.hideModal()
    },
  },
}
</script>

<style scoped lang="scss">
.delete-order-container {
  padding: 12px 24px 24px;
  overflow-y: auto;

  .button-group {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
